import { render, staticRenderFns } from "./PillarTitleAdd.vue?vue&type=template&id=055e4398&"
import script from "./PillarTitleAdd.vue?vue&type=script&lang=js&"
export * from "./PillarTitleAdd.vue?vue&type=script&lang=js&"
import style0 from "./PillarTitleAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports